/**
 * Supabase client initialization.
 * Connects to marsbot Supabase project (canonical backend).
 */

import { createClient, SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://loygyzhukfxdztkwfimr.supabase.co';
const SUPABASE_KEY = 'sb_publishable_EyuZI-gkaxI3jE6-sI_I3g_yBBOvE6S';

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!client) {
    client = createClient(SUPABASE_URL, SUPABASE_KEY);
  }
  return client;
}

export function getSessionId(): string {
  let sessionId = sessionStorage.getItem('studio_session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('studio_session_id', sessionId);
  }
  return sessionId;
}
